<template>
  <div id="kktu-select" v-if="isShow()">
    <div class="row">
      <label class="form-label">Категория KKTU</label>
      <span class="col-12">
        <Select :payload="{
          value: fields.kktu,
          items: fields.items,
          label: 'Выберите категорию KKTU',
          validator: fields.validator,
        }" @onChangeVal="onChange"/>
      </span>
      <div class="mt-2">
        <span class="col-12" v-if="isShowChild()">
          <Select :payload="{
            value: null,
            items: fields.itemsChild,
            label: 'Выберите вложенную категорию KKTU',
            validator: null,
          }" @onChangeVal="onChangeChild"/>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, onMounted, reactive, ref} from "vue"
import Select from "./components/select/Index"
import Api from "./services/Api"

export default defineComponent({
  name: "Kktu",
  emits: [
    'onUpdate'
  ],
  components: {
    Select,
  },
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, {emit}) {
    let show = ref(false)
    let showChild = ref(false)
    const fields = reactive({
      validator: {},
      kktu: null,
      items: [],
      itemsChild: [],
    })

    onMounted(async () => {
      markUnshow()

      await updateFields(props.payload)

      setItems(await getCategories({
        "code": "",
      }))
      markShow()
    })

    function setItems(val) {
      fields.items = val
    }

    async function updateFields(query) {
      fields.kktu = query.kktu
      fields.validator = query.validator
    }

    function markShow() {
      show.value = true
    }

    function markUnshow() {
      show.value = false
    }

    async function getCategories(query = {}) {
      let resp = await Api.categoryKktu(query)

      let items = resp["items"]

      const result = [];
      items.forEach(cat => {
        result.push({
          value: cat["code"],
          title: cat["name"],
          path: cat["str_path"],
          level: cat["level"],
        });
      });

      return result
    }

    function isShow() {
      return show.value === true
    }

    async function onChange(value) {
      unmarkShowChild()
      await setItemsChild([])

      if (value["category_id"] === null || value["category_id"] === undefined) {
        emit("onUpdate", getResult(value["category_id"]))
        return
      }

      let itemsChild = await getCategories({
        "code": value["category_id"],
      })

      if (itemsChild.length > 0) {
        await setItemsChild(itemsChild)
        markShowChild()
      }
      
      emit("onUpdate", getResult(value["category_id"]))
    }

    function getResult(categoryId) {
      return {
        category_id: categoryId,
      }
    }

    async function onChangeChild(value) {
      emit("onUpdate", getResult(value["category_id"]))
    }

    async function setItemsChild(items) {
      fields.itemsChild = items
    }

    function markShowChild() {
      showChild.value = true
    }

    function unmarkShowChild() {
      showChild.value = false
    }

    function isShowChild() {
      return showChild.value === true
    }

    return {
      isShow,
      isShowChild,
      onChange,
      onChangeChild,
      fields,
    }
  }
})
</script>
